import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = {
  key: 1,
  class: "error-msg"
}

import { IOptionsSelect } from '@/types';
import { withDefaults, watch, computed } from 'vue';
interface IProps {
  customNoDataText?: string;
  prependIconInList?: boolean;
  prependIcon?: string;
  modelValue?: any[];
  options?: IOptionsSelect[];
  placeholder?: string;
  label?: string;
  width?: string;
  height?: string;
  multiple?: boolean;
  disabled?: boolean;
  isCalendar?: boolean;
  required?: boolean;
  hasError?: boolean;
  msgError?: string;
  enableLoad: boolean;
  onLoad?: any;
  handleSearch?: (value) => any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomMultiSelect',
  props: {
    customNoDataText: {},
    prependIconInList: { type: Boolean },
    prependIcon: {},
    modelValue: {},
    options: {},
    placeholder: { default: 'Selecione' },
    label: {},
    width: { default: 'auto' },
    height: {},
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean },
    isCalendar: { type: Boolean, default: false },
    required: { type: Boolean },
    hasError: { type: Boolean },
    msgError: {},
    enableLoad: { type: Boolean, default: false },
    onLoad: {},
    handleSearch: {}
  },
  emits: ['onChangeDropDownList', 'update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

function handleChangeDropdownList() {
  emit('onChangeDropDownList', selectedItem.value);
}

const selectedItem = computed({
  get: () => (!props.modelValue ? null : props.modelValue),
  set: (value) => emit('update:modelValue', value),
});

watch(
  () => props.options,
  () => {
    if (!selectedItem.value) selectedItem.value = props.options?.filter((x) => x.selected === true)?.map((e) => e.value) ?? [];
    emit('onChangeDropDownList', selectedItem.value);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createElementBlock("div", {
    class: "multi-select",
    style: _normalizeStyle({ width: props.width })
  }, [
    (props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_v_autocomplete, {
      "item-title": "text",
      modelValue: selectedItem.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((selectedItem).value = $event)),
        handleChangeDropdownList
      ],
      density: "compact",
      variant: "outlined",
      color: "primary",
      class: _normalizeClass(["input-wapper", _ctx.hasError ? 'error' : 'border-without-err']),
      placeholder: selectedItem.value && selectedItem.value.length > 0 ? undefined : props.placeholder,
      items: props.options,
      multiple: "",
      chips: true,
      "closable-chips": true,
      required: _ctx.required,
      disabled: props.disabled,
      "item-value": "value",
      clearable: true,
      "onUpdate:search": _ctx.handleSearch,
      "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (selectedItem.value = [])),
      "no-data-text": props.customNoDataText
    }, _createSlots({
      prepend: _withCtx(() => [
        _renderSlot(_ctx.$slots, "prependIcon")
      ]),
      _: 2
    }, [
      (_ctx.prependIconInList)
        ? {
            name: "item",
            fn: _withCtx(({ props, item }) => [
              _createVNode(_component_v_list_item, _mergeProps(props, {
                "prepend-icon": item.value,
                title: item.title
              }), null, 16, ["prepend-icon", "title"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "class", "placeholder", "items", "required", "disabled", "onUpdate:search", "no-data-text"]),
    (_ctx.hasError && _ctx.msgError)
      ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString(_ctx.msgError), 1))
      : _createCommentVNode("", true)
  ], 4))
}
}

})